import type { ApryseRect } from '../../types/extraction';

/**
 * Generate a location anchor from page number and bounding rectangle.
 * Format: '{pageNum}:{x1}:{y1}:{x2}:{y2}'
 */
export function generateLocationAnchor(pageNumber: number, rect: ApryseRect): string {
  const [x1, y1, x2, y2] = rect;
  return `${pageNumber}:${x1}:${y1}:${x2}:${y2}`;
}

/**
 * True when a location anchor came from a PDF (Apryse) document. PDF anchors
 * are the `{pageNum}:{x1}:{y1}:{x2}:{y2}` coordinate strings produced by
 * `generateLocationAnchor` — five colon-separated numbers. Aline/DOCX anchors
 * are 12-character alphanumeric nanoids with no colons, so they never match.
 */
export function getIsPdfLocationAnchor(locationAnchor: string): boolean {
  const parts = locationAnchor.split(':');
  return parts.length === 5 && parts.every(part => !Number.isNaN(Number(part)));
}
